<div class="l_flexbar guts-p-full-1" *ngIf="!isLoading; else skeleton">
  <div aria-hidden="true">
    <!-- prevent screenreader seeing this to avoid redundancy with username -->
    <dgx-profile-pic
      [profile]="authUser.viewerProfile"
      size="smallish"
      class="app-header__profile-pic"
      data-dgat="user-summary-731"
      (click)="navigateToProfile()"
    ></dgx-profile-pic>
  </div>
  <div class="guts-p-l-1-half l_flex-grow l_flex__ellipsis-wrapper">
    <div>
      <a
        href="{{ profileUrl }}"
        (click)="trackClick('Name')"
        class="font-semibold par par--small no-wrap ellipsis block"
        [attr.title]="authUser.viewerProfile.name"
        data-dgat="user-summary-a1d"
        >{{ authUser.viewerProfile.name }}</a
      >
    </div>
    <div *ngIf="flexEdAvailableBalance">
      <a
        [attr.href]="flexEdUrl"
        (click)="trackClick('Flex-Ed Amount')"
        class="color-ebony-a61 par par--small no-wrap"
        [innerHTML]="
          'dgUtilityBar_FlexEdFormat'
            | translate: { available: flexEdAvailableBalance }
        "
        data-dgat="user-summary-da0"
      ></a>
    </div>
    <div
      *ngIf="!flexEdAvailableBalance && masteryPoints && showPoints"
      class="color-ebony-a61 zeta no-wrap guts-p-t-quart"
      translate="dgUtilityBar_MasteryPointsFormat"
      [translateParams]="{ masteryPoints: masteryPoints }"
    ></div>
  </div>
</div>

<ng-template #skeleton>
  <div
    class="
      skeleton-container
      l_flexbar
      skeleton--userSummary
      guts-p-t-1 guts-p-l-1
    "
  >
    <div class="l_flex-top">
      <div
        class="
          skeleton__circle skeleton__circle--medium
          bg-animate
          center-item
          m-guts-m-b-1
        "
      ></div>
      <div class="ring"></div>
    </div>
    <div class="grid guts-p-l-1-half guts-m-t-half">
      <div
        class="skeleton__line bg-animate grid__col-9 guts-m-b-1 guts-p-full-0"
      ></div>
      <div
        class="skeleton__line bg-animate grid__col-6 guts-m-b-2 guts-p-full-0"
      ></div>
    </div>
  </div>
</ng-template>
